'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjsr_AnonFunction2() {
}
export { $c_sjsr_AnonFunction2 as $c_sjsr_AnonFunction2 };
$p = $c_sjsr_AnonFunction2.prototype = new $j_java$002elang$002e$002dObject.$h_sr_AbstractFunction2();
$p.constructor = $c_sjsr_AnonFunction2;
/** @constructor */
function $h_sjsr_AnonFunction2() {
}
export { $h_sjsr_AnonFunction2 as $h_sjsr_AnonFunction2 };
$h_sjsr_AnonFunction2.prototype = $p;
